import React from "react";
import { Link } from "react-router-dom";
import { Crown, HeartCrack } from "lucide-react";

export default function DonationCancel() {
  return (
    <main
      data-testid="donation-cancel-page"
      className="min-h-screen bg-[#FAF7F2] text-[#2C1E23] flex flex-col"
    >
      <header className="max-w-[1200px] mx-auto w-full px-6 py-8 flex items-center gap-3">
        <span className="w-10 h-10 border border-[#4A192C] flex items-center justify-center">
          <Crown className="w-5 h-5 text-[#4A192C]" />
        </span>
        <span className="font-serif-display text-xl text-[#4A192C]">
          Le Sanctuaire des Mères
        </span>
      </header>

      <div className="flex-1 flex items-center">
        <div className="max-w-[720px] mx-auto px-6 py-20 text-center">
          <HeartCrack className="w-12 h-12 text-[#D98A6C] mx-auto" />
          <p className="sdm-divider mt-8">Paiement annulé</p>
          <h1 className="font-serif-display text-5xl text-[#4A192C] mt-6 leading-tight">
            Votre don n&apos;a pas été effectué.
          </h1>
          <p className="mt-4 text-[#6B585F] max-w-lg mx-auto leading-relaxed">
            Aucun montant n&apos;a été débité. Revenez quand vous le souhaitez —
            le Sanctuaire vous attend.
          </p>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/#don" data-testid="retry-donation-button" className="sdm-btn-primary">
              Réessayer
            </Link>
            <Link to="/" className="sdm-btn-ghost">
              Retour à l&apos;accueil
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
